import { CustomLoader } from "../../modals/loader-subjects/loader";

export class GridLoader extends CustomLoader {

}